export const getEngravingState = (item) => item?.engravingState || (item?.engravedAt ? 'confirmed' : 'none');

export const itemBadge = (item) => {
  switch (getEngravingState(item)) {
    case 'confirmed':
      return { label: 'Engraved', className: 'bg-emerald-50 text-emerald-700' };
    case 'failed':
      return { label: 'Needs attention: last attempt failed', className: 'bg-red-50 text-red-700' };
    case 'unconfirmed':
      return { label: 'Needs attention: result not confirmed', className: 'bg-amber-50 text-amber-800' };
    case 'stopped':
      return { label: 'Stopped', className: 'bg-gray-100 text-gray-600' };
    default:
      return null;
  }
};

export const allConfirmed = (items) => items.length > 0
  && items.every((item) => getEngravingState(item) === 'confirmed');

export const mainActionLabel = (item) => getEngravingState(item) === 'none' ? 'Engrave' : 'Re-engrave';
